import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomImage, CustomPageHeader, Text } from '@src/components';

import InstructionInformations from './instructionInformations';
import OrderSummary from './orderSummary';
import Completed from './Completed';
import Payment from './payment';

import { getAppSettings } from '@src/store/slice/appSettingsSlice';
import { prevStep } from '@src/store/slice/autoUploadInstructionsSlice';

import { isCreditCardUser } from '@src/utils/utils';

import { Steps } from 'antd';

import iconFinish from '@src/assets/icons/icon-done.svg';
import '@src/styles/balanceUpload/balanceUpload.scss';
import '@src/styles/autoUploadInstruction/autoUploadInstructions.scss';

const { Step } = Steps;

const steps = [
  {
    title: <Text t="instructionEntry" />,
    content: InstructionInformations,
  },
  {
    title: <Text t="instructionSummary" />,
    content: OrderSummary,
  },
  {
    title: <Text t="payment" />,
    content: Payment,
    key: 'payment',
  },
  {
    title: <Text t="approval" />,
    content: Completed,
  },
];

const activeStepKeys = steps.map((item) => item.key);

function getProgressDot() {
  return (_, { index, status }) =>
    status === 'finish' ? <CustomImage src={iconFinish} /> : index + 1;
}

const NewInstruction = () => {
  const dispatch = useDispatch();

  const { activeStep } = useSelector((state) => state?.autoUploadInstructions);
  const { customerVou } = useSelector((state) => state?.customer);

  const [_step, _setStep] = useState(steps);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAppSettings({ code: 'AutoLoadingInfo' }));
  }, [activeStep, dispatch]);

  const stepChange = useCallback(
    (current) => {
      if (activeStep - 1 === current) {
        dispatch(prevStep());
      }
    },
    [activeStep, dispatch],
  );
  const StepContent = steps[activeStep].content;

  useEffect(async () => {
    if (!customerVou?.pamId) return;
    if (!isCreditCardUser(customerVou)) {
      if (activeStepKeys[activeStep] === 'payment') {
        stepChange(0);
      }
      const withOutPaymentTab = steps.filter((item) => item.key !== 'payment');
      if (withOutPaymentTab.length === steps.length || withOutPaymentTab.length !== 3) return;
      _setStep([...withOutPaymentTab]);
    }
  }, [customerVou]);

  return (
    <CustomPageHeader
      data-testid="new-instruction"
      title={<Text t="automaticInstallationInstruction" />}
      showBreadCrumb
      showHelpButton
      routes={['Ticket Restaurant', 'automaticInstallationInstructions']}
    >
      <div className="auto-upload-instructions">
        <Steps
          onChange={stepChange}
          current={activeStep}
          className="card-order-steps"
          labelPlacement="vertical"
          progressDot={getProgressDot()}
        >
          {_step.map((item) => (
            <Step key={item.title} title={item.title} disabled={activeStep === 3} />
          ))}
        </Steps>
      </div>

      <StepContent />
    </CustomPageHeader>
  );
};

export default NewInstruction;
